/*eslint-disable*/
import React, { useState } from "react";

import CustomIconButton from "../Buttons/CustomIconButton";
import { FiEdit, FiBell, FiCalendar } from "react-icons/fi";
import { HiShare } from "react-icons/hi2";

import UserAccessManager from "../AccessControl/UserAccessManager"; // Import the UserAccessManager component

import { ClientHeaderProps } from "../../types/client_header.t";

// PercentageFilled component
interface PercentageFilledProps {
    percentage: number;
}

const PercentageFilled: React.FC<PercentageFilledProps> = ({ percentage }) => {
    // Calculate the stroke-dashoffset based on the percentage
    const strokeDasharray = 2 * Math.PI * 18; // Circumference of circle with radius 18
    const strokeDashoffset =
        strokeDasharray - (strokeDasharray * percentage) / 100;

    return (
        <div className="flex items-center justify-center relative">
            <svg
                width="40" // Adjusted size
                height="40" // Adjusted size
                viewBox="0 0 40 40" // Adjusted viewBox for smaller size
                xmlns="http://www.w3.org/2000/svg"
                className="transform rotate-90"
            >
                {/* Background circle */}
                <circle
                    cx="20" // Centered within 40x40
                    cy="20" // Centered within 40x40
                    r="18" // Smaller radius to fit within 40x40
                    stroke="#e5e7eb" // Light gray background border
                    strokeWidth="4" // Reduced stroke width for smaller size
                    fill="none"
                />
                {/* Foreground circle with percentage */}
                <circle
                    cx="20" // Centered within 40x40
                    cy="20" // Centered within 40x40
                    r="18" // Smaller radius to fit within 40x40
                    stroke="#16a34a" // Use dynamic logic for the border color
                    strokeWidth="4" // Reduced stroke width
                    fill="none"
                    strokeDasharray={strokeDasharray}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    style={{
                        transition: "stroke-dashoffset 0.3s ease",
                    }}
                />
            </svg>
            {/* Percentage text centered inside the circle */}
            <span className="absolute text-xs text-black font-bold">
                {percentage}%
            </span>
        </div>
    );
};

const ClientHeader: React.FC<ClientHeaderProps> = ({
    client_name,
    client_id,
    city,
    totalValue,
    leadStage,
    percentageFilled,
    onStartVisit,
    onSetReminder,
    onOpenModal,
}) => {
    // Determine the color based on percentageFilled
    let textColor = "";
    let backgroundColor = "";

    if (percentageFilled <= 50) {
        textColor = "#dc2626"; // Red
        backgroundColor = "#fef2f2"; // Light Red
    } else if (percentageFilled <= 80) {
        textColor = "#f97316"; // Orange
        backgroundColor = "#fff7ed"; // Light Orange
    } else {
        textColor = "#16a34a"; // Green
        backgroundColor = "#d1fae5"; // Light Green
    }

    const [isModalOpen, setIsModalOpen] = useState(false);

    // Toggle the modal state between true and false
    const toggleModal = () => {
        setIsModalOpen((prevState) => !prevState);
    };

    return (
        <div className="text-left text-black font-lg font-bold md:border-b md:border-black w-full flex-col flex ">
            {/* Client name */}

            <div className="flex flex-row md:w-1/3 justify-between items-center">
                <div className="text-xl">
                    {client_name}, <span className="">{city}</span>
                </div>
                {/* <div className="text-xxs text-gray-500 mt-2">{client_id}</div> */}

                <button
                    onClick={() => setIsModalOpen(true)}
                    className="bg-white border border-black rounded-full text-black px-3 py-1 text-sm hidden md:block"
                >
                    Accès
                </button>
            </div>

            {isModalOpen && (
                <UserAccessManager onClose={toggleModal} clientId={client_id} />
            )}

            <div className="flex flex-row justify-between  mt-4 w-full md:w-1/5 items-start block md:hidden">
                <div className="flex flex-col items-center">
                    <CustomIconButton
                        onClick={onOpenModal}
                        icon={<FiCalendar className="text-2xl" />}
                        sx={{ backgroundColor: "#F0F0F0", fontSize: "18px" }}
                    />
                    <span className="text-xxs mt-2 text-gray-500">Réunion</span>
                </div>

                <div className="flex flex-col items-center">
                    <CustomIconButton
                        onClick={onStartVisit}
                        icon={<FiEdit className="text-2xl" />}
                        sx={{ backgroundColor: "#F0F0F0", fontSize: "18px" }}
                    />
                    <span className="text-xxs mt-2 text-gray-500">
                        Compte rendu
                    </span>
                </div>

                <div className="flex flex-col items-center">
                    <CustomIconButton
                        onClick={onSetReminder}
                        icon={<FiBell className="text-2xl" />}
                        sx={{ backgroundColor: "#F0F0F0", fontSize: "18px" }}
                    />
                    <span className="text-xxs mt-2 text-gray-500">Rappel</span>
                </div>
                <div className="flex flex-col items-center block md:hidden">
                    <CustomIconButton
                        onClick={toggleModal}
                        icon={<HiShare className="text-2xl" />}
                        sx={{ backgroundColor: "#F0F0F0", fontSize: "18px" }}
                    />
                    <span className="text-xxs mt-2 text-gray-500">Accès</span>
                </div>
            </div>
        </div>
    );
};

export default ClientHeader;
